exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mystore .vux-x-dialog-absolute .weui-dialog {\n    position: fixed !important;\n}\n/* .coupon_show .border:before {\n    z-index: -1 !important;\n    left: -0.5% !important;\n    top: -0.5% !important;\n} */\n.descripe .weui-dialog {\n    padding: 30px !important;\n}\n", ""]);

// exports
